import React from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
// react component used to create a calendar with events on it
import BigCalendar from "react-big-calendar";
// dependency plugin for react-big-calendar
import moment from "moment";
import "moment/locale/es";
import { duration } from "moment";
// react component used to create alerts
import SweetAlert from "react-bootstrap-sweetalert";

import { PanelHeader, Button } from "components";

import { events, newEvents, calendars } from "variables/general.jsx";

import ReactCalendar from "@toast-ui/react-calendar";
import "tui-calendar/dist/tui-calendar.css";
import "tui-date-picker/dist/tui-date-picker.css";
import "tui-time-picker/dist/tui-time-picker.css";
import ReactDOMServer from "react-dom/server";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
const CITA = "cita";
const daynames = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];

//function to group array by param. Usage:
//        const groupByParamA = groupBy('paramA');
//        const groupedElements = groupByParamA(elements);
const groupBy = key => array =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});

var latestClick = [];
var buttonStackLoaded = false;
const DIA = "dia";
const SEMANA = "semana";
const SEIS_SEMANAS = "6semanas";
const ANTERIOR = "anterior";
const HOY = "hoy";
const SIGUIENTE = "siguiente";
const WAIT_INTERVAL = 1000;

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

class Reminders extends React.Component {
  constructor(props) {
    super(props);
    let existingEvents = null;
    // if (this.props.mainState.homeVisits && this.props.mainState.homeVisits.list) existingEvents = this.props.mainState.homeVisits.list;
    var now = moment();
    var monday = now.clone().weekday(0);//.subtract(5, 'weeks');
    var sunday = now.clone().weekday(6);//.add(5, 'weeks');
    this.state = {
      events: [],
      reminders: [],
      newEvents: existingEvents || [],
      alert: null,
      date_day_min: monday,
      date_day_max: sunday,
      homeVisits: [],
      buttonStack: [],
      showLog: false
    };
    // console.log("this.props.mainState", this.props.mainState);
    if ("reminders" in this.props.mainState.sessionConfig) {
      let existingConfig = this.props.mainState.sessionConfig["reminders"];
      this.state = existingConfig;
    }
    // console.log("state", this.state);
    this.hideAlert = this.hideAlert.bind(this);
    this.onBeforeCreateSchedule = this.onBeforeCreateSchedule.bind(this);
    this.onBeforeDeleteSchedule = this.onBeforeDeleteSchedule.bind(this);
    this.onBeforeUpdateSchedule = this.onBeforeUpdateSchedule.bind(this);
    this.onClickSchedule = this.onClickSchedule.bind(this);
    this.cancelScheduleChanges = cancelScheduleChanges.bind(this);
    this.changeReminderDate = this.changeReminderDate.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
    this.addButtonToStack = this.addButtonToStack.bind(this);
    this.loadButtonStack = this.loadButtonStack.bind(this);
    this.loadRangeEvents = this.loadRangeEvents.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    if (!(this.state.buttonStack && this.state.buttonStack.length > 0)) {
      let start = this.state.date_day_min.format("YYYY-MM-DD");
      let end = this.state.date_day_max.format("YYYY-MM-DD");
      this.listReminders(start, end);
      // let filter = {
      //   "date_from": this.state.date_day_min,
      //   "date_to": this.state.date_day_max,
      // };
      // console.log("filter", filter);
      // this.props.userData.searchHomeVisits("", this.state.date_day_min, this.state.date_day_max);
    }
    this.props.userData.getCalendarsList();
    // this.props.userData.getHomeVisitsLog();
    buttonStackLoaded = false;
    // let calendar = this.refs.cal.calendarInst;
    // calendar.setOptions({week: {startDayOfWeek: 1}}, true);
  }
  componentWillUnmount() {
    // console.log("unmounting calendar");
    this.props.saveSessionConfig("reminders", this.state);
  }
  handleChange() {
    clearTimeout(this.timer);
    this.timer = setTimeout(this.loadRangeEvents, WAIT_INTERVAL);
  }
  addButtonToStack(button) {
    let buttonStack = this.state.buttonStack;
    if (!buttonStack) buttonStack = [];
    buttonStack.push(button);
    this.setState({ buttonStack: buttonStack });
  }
  loadButtonStack() {
    // console.log("loading button Stack", this.state.buttonStack);
    if (this.state.buttonStack && this.state.buttonStack.length > 0) {
      let buttonStack = this.state.buttonStack;
      buttonStack.map(button => {
        // console.log("vamos a pulsar el botón --> ", button);
        let calendar = this.refs.cal.calendarInst;
        // console.log("reminders", calendar);
        let currentView = "";
        switch (button) {
          case DIA:
            // console.log("pulsando el botón --> ", button);
            calendar.changeView("day");
            currentView = "day";
            break;
          case SEMANA:
            // console.log("pulsando el botón --> ", button);
            calendar.changeView("week");
            currentView = "week";
            break;
          case SEIS_SEMANAS:
            // console.log("pulsando el botón --> ", button);
            calendar.setOptions({month: {visibleWeeksCount: 6}}); // or null
            calendar.changeView("month", false);
            currentView = "month";
            break;
          case ANTERIOR:
            // console.log("pulsando el botón --> ", button);
            calendar.prev();
            break;
          case HOY:
            // console.log("pulsando el botón --> ", button);
            calendar.today();
            break;
          case SIGUIENTE:
            // console.log("pulsando el botón --> ", button);
            calendar.next();
            break;
        }
        this.setState({ currentView: currentView });
        setTimeout((function() {
          this.scrollToBottom();
        }).bind(this), 200);
      });
    }
  }
  scrollToBottom() {
    let last = document.getElementById("ultimo");
    last.scrollIntoView({behavior: "auto"});
    // console.log("scroll to bottom");
  }
  componentDidUpdate(prevProps, prevState) {
    // console.log("this.state in componentDidUpdate(Calendar)", this.state);
    // console.log("this.refs.cal", this.refs.cal);
    // console.log("this.refs.cal.calendarInst", this.refs.cal ? this.refs.cal.calendarInst : null);
    // console.log("this.refs.cal.calendarInst.getDateRangeStart()", this.refs.cal ? this.refs.cal.calendarInst.getDateRangeStart() : null);
    // console.log("this.refs.cal.calendarInst.getDateRangeEnd()", this.refs.cal ? this.refs.cal.calendarInst.getDateRangeEnd() : null);

    // console.log("");
    // console.log("#######################################################");
    // console.log("     Update calendar, time:", moment().toISOString());
    // console.log("#######################################################");
    // console.log("");
    if (this.refs.cal && !buttonStackLoaded) {
      buttonStackLoaded = true;
      this.loadButtonStack();
    }
  }
  loadRangeEvents() {
    if (this.refs.cal && this.refs.cal.calendarInst) {
      let rangeStart = moment(this.refs.cal.calendarInst.getDateRangeStart().getTime()).format("YYYY-MM-DD");
      let rangeEnd = moment(this.refs.cal.calendarInst.getDateRangeEnd().getTime()).format("YYYY-MM-DD");
      // console.log("LOAD RANGE START", rangeStart);
      // console.log("LOAD RANGE END", rangeEnd);
      this.listReminders(rangeStart, rangeEnd);
    }
  }
  async listReminders(start, end) {
    let filter = {
      date_from: start,
      date_to: end
    };
    this.setState({ listingReminders: true });
    this.props.userData.listReminders(filter).then(result => {
      this.setState({ listingReminders: false });
      if (result.ok) {
        this.setState({
          reminders: result.reminders,
        });
      } else {
        console.log("Something went wrong listing reminders: " + result.error);
      }
    })
    .catch((error) => {
      this.setState({ listingReminders: false });
      // Error 😨
      console.log("Something went wrong listing reminders: " + error.message);
      // console.log("Error al obtener los impuestos y los conceptos: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
    // filter.page = filter.page - 1;
  }
  async changeReminderDate(schedule, changes) {
    // console.log("changes", schedule);
    let reminder = {
      date: moment(changes.start.getTime()).format("YYYY-MM-DD HH:mm"),
      id: schedule.id
    };
    // console.log("homeVisit", homeVisit);
    this.props.userData.changeReminderDate(reminder).then(result => {
      if (result.ok) {
        this.loadRangeEvents();
      } else {
        console.log("Something went wrong editing the reminder: " + result.error);
      }
    })
    .catch((error) => {
      // Error 😨
      console.log("Something went wrong editing the reminder: " + error.message);
      // console.log("Error al obtener los impuestos y los conceptos: " + error.message);
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  getEventColor(type) {
    let resultStyle = {};
    let resultText = {};
    type = parseInt(type);
    switch (type) {
      case 415:
        resultText = "Para mí";
        resultStyle = "btn-primary";
        return "#46B98A";
        break;
      case 416:
        resultText = "Para todos";
        resultStyle = "btn-danger";
        return "#c0392b";
        break;
      default:
        resultText = "Error en el tipo";
        resultStyle = "btn-default";
        return "#888888";
    }
  }
  selectedEvent(event) {
    alert(event.title);
  }
  // shouldComponentUpdate(nextProps) {
  //   if (!this.props.mainState.lastLoadedCalendar) return true;
  //   return this.props.mainState.lastLoadedCalendar < nextProps.mainState.lastLoadedCalendar;
  // }
  addNewEventAlert(slotInfo) {
    // console.log("");
    // console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~");
    // console.log("     addNewEventAlert, time:", moment().toISOString());
    // console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~");
    // console.log("");
    this.setState({
      alert: (
        <SweetAlert
          input
          showCancel
          style={{ display: "block", marginTop: "-100px" }}
          title="Input something"
          onConfirm={e => this.addNewEvent(e, slotInfo)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
        />
      )
    });
  }
  addNewEvent(e, slotInfo) {
    var newEvents = this.state.events;
    newEvents.push({
      title: e,
      start: slotInfo.start,
      end: slotInfo.end
    });
    this.setState({
      alert: null,
      events: newEvents
    });
  }
  hideAlert() {
    this.setState({
      alert: null,
      scheduleUpdating: null
    });
  }
  eventColors(event, start, end, isSelected) {
    var backgroundColor = "event-";
    event.color
      ? (backgroundColor = backgroundColor + event.color)
      : (backgroundColor = backgroundColor + "default");
    return {
      className: backgroundColor
    };
  }
  onClickSchedule(e) {
    // console.log("redirect citas", e);
    let schedule = e.schedule;
    let lastClick = 0;
    if (schedule.id in latestClick) {
      lastClick = latestClick[schedule.id];
      let now = moment();
      if (now - lastClick < 1500)
        // console.log("URL", "/citas/" + e.schedule.id);
        this.setState({ lastViewed: parseInt(e.schedule.id) });
        this.redirectTo("/recordatorios/" + e.schedule.id);
    }
    latestClick[schedule.id] = moment();

    // this.setState({ redirect: "/citas/" + e.schedule.id });
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  onBeforeCreateSchedule(scheduleData) {
    // console.log("CREATE reminder");
    // console.log(scheduleData);
    let reminder = {
      title: scheduleData.title,
      start: moment(scheduleData.start.getTime()).toISOString(),
      end: moment(scheduleData.end.getTime()).toISOString()
    };
    localStorage.setItem('reminder_from_calendar', JSON.stringify(reminder));
    // console.log("test");
    // console.log(test);
    // return;
    // this.props.userData.createHomeVisitFromCalendar(scheduleData);
    // this.props.userData.createReminderFromCalendar(scheduleData);
    // this.setState({ redirect: "/citas/nueva" });
    this.redirectTo("/recordatorios/nuevo");
    return;

    const schedule = {
      id: String(Math.random()),
      title: scheduleData.title,
      isAllDay: scheduleData.isAllDay,
      start: scheduleData.start,
      end: scheduleData.end,
      category: scheduleData.isAllDay ? "allday" : "time",
      dueDateClass: "",
      location: scheduleData.location,
      raw: {
        class: scheduleData.raw["class"]
      },
      state: scheduleData.state,
      calendarId: scheduleData.calendarId
    };
    console.log(this.refs);
    this.refs.cal.calendarInst.createSchedules([schedule]);
  }
  onBeforeDeleteSchedule(res) {
    console.log("DELETE SCHEDULE");
    console.log(res);
    const { id, calendarId } = res.schedule;
    let calendar = this.refs.cal.calendarInst;
    calendar.deleteSchedule(id, calendarId);
  }
  onBeforeUpdateSchedule(e) {
    // console.log("UPDATE SCHEDULE");
    // console.log(e);
    const { schedule, changes } = e;

    let calendar = this.refs.cal.calendarInst;
    // console.log("CHANGES TO UPDATE", {
    //   schedule_id: schedule.id,
    //   calendar: schedule.calendarId,
    //   changes: changes
    // });
    
    if (changes.start && schedule.start.getTime() !== changes.start.getTime()) {
      this.setState({
        alert: (
          <SweetAlert
            // input
            showCancel
            style={{ display: "block", marginTop: "-100px" }}
            title="¿Aplicar cambios?"
            onConfirm={e => {
              console.log("REMINDER DATE UPDATE CONFIRMED");
              this.changeReminderDate(schedule, changes);
              this.hideAlert();
            }}
            onCancel={() => {
              this.cancelScheduleChanges();
              this.hideAlert();
            }}
            confirmBtnBsStyle="primary"
            cancelBtnBsStyle="default"
            confirmBtnText="Guardar"
            cancelBtnText="Descartar"
          />
        ),
        scheduleUpdating: { ...schedule }
      });
    }

    calendar.updateSchedule(schedule.id, schedule.calendarId, changes, true);
  }
  render() {
    // if (this.state.redirect) this.redirectTo(this.state.redirect);
    let events = [];
    let remindersIds = [];
    if (this.state.reminders && Object.keys(this.state.reminders).length > 0) {
      // console.log("reminders", this.state.reminders);
      remindersIds = Object.keys(this.state.reminders);
      remindersIds.forEach(reminderId => {
        events.push(this.state.reminders[reminderId]);
      });
      // events = this.state.reminders;
    }
    // console.log("events", events);
    // let showLoadingLogMessage = this.props.mainState.isSearchingHomeVisitsLog || !this.props.mainState.log || 
    //   !this.props.mainState.log.homeVisits || !("all" in this.props.mainState.log.homeVisits);
    let calendarRange = null;
    if (this.refs.cal && this.refs.cal.calendarInst) {
      let rangeStartUNIX = this.refs.cal.calendarInst.getDateRangeStart().getTime();
      let rangeEndUNIX = this.refs.cal.calendarInst.getDateRangeEnd().getTime();
      let rangeStart = moment(rangeStartUNIX).format("DD/MM/YYYY");
      let rangeEnd = moment(rangeEndUNIX).format("DD/MM/YYYY");
      calendarRange = rangeStart;
      if (rangeStart !== rangeEnd) {
        calendarRange = "Mostrando del " + rangeStart + " al " + rangeEnd;
      }
    }
    return (
      <div>
        <PanelHeader
          size="sm"
          // content={
          //   <div className="header text-center">
          //     <h2 className="title">Calendario</h2>
          //     <p className="category">
          //       Calendario de eventos
          //     </p>
          //   </div>
          // }
        />
        <div className={"content " + (this.refs.cal ? this.refs.cal.calendarInst.getViewName() : "")}>
          {this.state.alert}
          <Row>
            <Col>
              <Card className="card-calendar">
                <CardBody>
                  <Button
                    // icon
                    round
                    key={"dayViewButton"}
                    color="info"
                    onClick={() => {
                      this.refs.cal.calendarInst.changeView("day");
                      this.addButtonToStack(DIA);
                      this.handleChange();
                      this.setState({ currentView: "day" });
                    }}
                    // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                    // leftLabel={"now-ui-icons ui-1_simple-add"}
                  >
                    Día
                  </Button>
                  <Button
                    // icon
                    round
                    key={"weekViewButton"}
                    color="info"
                    onClick={() => {
                      this.refs.cal.calendarInst.changeView("week");
                      this.addButtonToStack(SEMANA);
                      this.handleChange();
                      this.setState({ currentView: "week" });
                    }}
                    // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                    // leftLabel={"now-ui-icons ui-1_simple-add"}
                  >
                    Semana
                  </Button>
                  <Button
                    // icon
                    round
                    key={"6weekViewButton"}
                    color="info"
                    onClick={() => {
                      let calendar = this.refs.cal.calendarInst;
                      calendar.setOptions({month: {visibleWeeksCount: 6}}); // or null
                      calendar.changeView("month", false);
                      this.addButtonToStack(SEIS_SEMANAS);
                      this.handleChange();
                      this.setState({ currentView: "month" });
                    }}
                    // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                    // leftLabel={"now-ui-icons ui-1_simple-add"}
                  >
                    6 semanas
                  </Button>
                  <Button
                    icon
                    round
                    key={"previousViewButton"}
                    color="info"
                    onClick={() => {
                      let calendar = this.refs.cal.calendarInst;
                      calendar.prev();
                      this.handleChange();
                      this.addButtonToStack(ANTERIOR);
                    }}
                    // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                    leftLabel={"now-ui-icons arrows-1_minimal-left"}
                  />
                  <Button
                    // icon
                    round
                    key={"todayViewButton"}
                    color="info"
                    onClick={() => {
                      let calendar = this.refs.cal.calendarInst;
                      calendar.today();
                      this.handleChange();
                      this.addButtonToStack(HOY);
                    }}
                    // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                    // leftLabel={"now-ui-icons arrows-1_minimal-right"}
                  >Hoy</Button>
                  <Button
                    icon
                    round
                    key={"nextViewButton"}
                    color="info"
                    onClick={() => {
                      let calendar = this.refs.cal.calendarInst;
                      calendar.next();
                      this.handleChange();
                      this.addButtonToStack(SIGUIENTE);
                    }}
                    // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                    leftLabel={"now-ui-icons arrows-1_minimal-right"}
                  />
                  <Link to={"/recordatorios/nuevo"}>
                    <Button round color="primary">
                      <i className="now-ui-icons ui-1_simple-add" /> Nuevo recordatorio
                    </Button>
                  </Link>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {this.state.listingReminders && <Row>
            <Col xs={12} className="text-center txt-white">
              <Card color="primary">
                <CardBody>
                  <div>
                    <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando recordatorios
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>}
          {!this.state.listingReminders && <Row>
            <Col xs={12} className="text-center txt-white">
              <Card color="info" onClick={() => {this.loadRangeEvents();}} className="building-card">
                <CardBody>
                  <div>
                    <i className="now-ui-icons arrows-1_cloud-download-93" /> Buscar cambios
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>}
          {/* {showLoadingLogMessage && <Row>
            <Col xs={12} className="text-center txt-white">
              <Card color="default">
                <CardBody>
                  <div>
                    <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando log del calendario
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>} */}
          {/* {!showLoadingLogMessage && this.props.mainState.log.homeVisits["all"].length > 0 && !this.state.showLog && <Row>
            <Col xs={12} className="text-center txt-white">
              <Card color="default" style={{ cursor: "pointer" }} onClick={() => this.setState({ showLog: true })}>
                <CardBody>
                  <div>
                    <i className="now-ui-icons design_bullet-list-67" /> Mostrar log del calendario
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>} */}
          {/* {!showLoadingLogMessage && this.props.mainState.log.homeVisits["all"].length > 0 && this.state.showLog && <Row>
            <Col xs={12} className="text-left">
              <Card className="card-plain log-calendario">
                <CardBody>
                  <div className="text-center">
                    <i className="now-ui-icons education_agenda-bookmark" /> Log del calendario
                  </div>
                  <table width="100%" style={{}}>
                    <tbody>
                        {this.props.mainState.log.homeVisits["all"].map(log => {
                          let date_class = "log-date ";
                          let log_date = <span className={date_class}>{moment(log.date).fromNow()}</span>;
                          let log_content = (
                            <div>
                              {log_date}
                              <div dangerouslySetInnerHTML={{ __html: log.text }} />
                            </div>
                          );
                          if (log.hasRedirect) {
                            log_content = (
                              <Link to={"/citas/" + log.redirect.id}>
                                {log_content}
                              </Link>
                            );
                          }
                          log_content = (
                            <tr key={log.id}>
                              <td className="text-left">
                                {log_content}
                              </td>
                            </tr>
                          );
                          return log_content;
                        })}
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </Col>
            </Row>} */}
          <Row>
            <Col xs={12} md={12} className="ml-auto mr-auto">
              <Card className="card-calendar">
                <CardBody>
                  <span className="category">{calendarRange}</span>
                  <ReactCalendar
                    dr
                    ref="cal"
                    height="1350px"
                    calendars={this.props.mainState.calendarsList ? this.props.mainState.calendarsList : calendars}
                    schedules={events}
                    timezones={[
                      {
                        timezoneOffset:
                          parseInt(
                            moment()
                              .format("Z")
                              .split(":")[0]
                          ) * 60,
                        displayLabel: "GMT+01:00",
                        tooltip: "Madrid"
                      }
                    ]}
                    disableDblClick={false}
                    disableClick={true}
                    isReadOnly={false}
                    month={{
                      narrowWeekend: true,
                      startDayOfWeek: 1, // monday
                      daynames: daynames
                    }}
                    options={{
                      language: "es"
                    }}
                    scheduleViews
                    taskView={false}
                    template={{
                      milestone(schedule) {
                        console.log("milestone schedule", schedule);
                        // return `<span style="color:#fff;background-color: ${schedule.bgColor};">${
                        //   schedule.title
                        // }</span>`;
                        return (
                          <span style={{ color: "#FFF", backgroundColor: schedule.bgColor || "#CCC" }}>
                            <span>
                              {schedule.title}
                            </span>
                            <span>
                              <i
                                className="now-ui-icons location_pin"
                                style={{ color: "#F00" }}
                              />
                              {" " + schedule.category_name}
                            </span>
                          </span>
                        );
                      },
                      milestoneTitle() {
                        return 'Objetivo';
                      },
                      allday(schedule) {
                        console.log("allday schedule", schedule);
                        // return `${schedule.title}<i class="fa fa-refresh"></i>`;
                        return schedule.title;
                      },
                      alldayTitle() {
                        return "Todo el día";
                      },
                      monthGridHeaderExceed: function(hiddenSchedules) {
                        console.log("monthGridHeaderExceed hiddenSchedules", hiddenSchedules);
                        let text = "recordatorio";
                        if (hiddenSchedules > 1) text = "recordatorios";
                        return '<span class="weekday-grid-more-schedules category">Hay ' + hiddenSchedules + " " + text + ' más</span>';
                      },
                      time: function(schedule) {
                        console.log("time schedule", schedule);
                        let reminder = null;
                        let titleStyle = null;
                        let statusIcon = null;
                        let statusTime = null;
                        let durationStyle = null;
                        let targetStyle = null;
                        let reminders = this.state.reminders;
                        if (parseInt(schedule.id) in reminders) {
                          reminder = reminders[parseInt(schedule.id)];
                          // console.log("homeVisit relacionado con el evento", homeVisit);
                          // console.log("homeVisit - día", homeVisit.visit_date_day);
                          // console.log("homeVisit - hora", homeVisit.visit_date_hour);
                          // console.log("schedule correspondiente", schedule);
                          // console.log("schedule - día", moment(schedule.start.getTime()).format('DD/MM/YYYY'));
                          // console.log("schedule - hora", moment(schedule.start.getTime()).format('HH:mm'));
                          titleStyle = {
                            background: this.getEventColor(reminder.type_id),
                            marginTop: "0px",
                            paddingTop: "3px",
                            paddingBottom: "3px"
                            // opacity: homeVisit.opacity === "transparente" ? 0.2 : 1
                          };
                          durationStyle = {
                            background: "rgba(0,0,0,0.2)",
                            // fontWeight: 100,
                            padding: "3px 0px 3px 0px",
                            marginTop: "0px",
                            color: "#000 !important"
                            // marginBottom: "5px"
                          };
                          targetStyle = {
                            background: "rgba(0,0,0,0.2)",
                            // fontWeight: 100,
                            padding: "0px",
                            marginTop: "-1px",
                            color: "#FFF !important"
                            // marginBottom: "5px"
                          };
                          let reminderStatus = buildReminderHeaderStatus(reminder);
                          statusIcon = reminderStatus.icon;
                          statusTime = reminderStatus.time;
                        } else {
                          console.log("error al cargar el reminder relacionado del evento", schedule);
                          return `Error en el evento`;
                        }
                        
                        try {
                          let calendar = this.refs.cal.calendarInst;
                          let showDetails = calendar.getViewName() !== "month";
                          let contentToRender = null;
                            contentToRender = 
                            <Row className={"cita-opacidad-" + reminder.opacity} id={this.state.lastViewed === parseInt(reminder.id) ? "ultimo" : ""}>
                              {showDetails && <Col xs={12} style={targetStyle}>
                                {getReminderTarget(reminder)}
                              </Col>}
                              {/* <Col xs={12} style={titleStyle}> */}
                              <Col xs={12} >
                              {/* {statusIcon} */}
                              {!showDetails && <span style={{fontWeight: 400, marginRight: "5px"}}>{moment(schedule.start.getTime()).format("HH:mm")}</span>}{schedule.title}
                              </Col>
                              {showDetails && statusTime && 
                              <Col xs={12} className="text-center" style={durationStyle}>
                                <span  className="text-left" style={{fontWeight: "400"}}>{moment(schedule.start.getTime()).format("HH:mm")}</span>{" "}{statusTime}
                              </Col>}
                              {/* {showDetails && <Col xs={12} className="text-center" style={{fontWeight: "400"}}>
                                {moment(schedule.start.getTime()).format("HH:mm")}
                              </Col>} */}
                              {showDetails && reminder.description && <Col xs={12} className="text-left" style={{fontWeight: "400"}}>
                                <div dangerouslySetInnerHTML={{ __html: reminder.description }} />
                              </Col>}
                              {/* {showDetails && <Col xs={12}>
                                <span style={{ color: "rgba(0,0,0,0.4)", fontSize: "12px" }}>
                                  {(homeVisit ? homeVisit.visit_address : "")}
                                </span>
                              </Col>} */}
                            </Row>;
                          // console.log("test event", homeVisit);
                          return ReactDOMServer.renderToStaticMarkup(contentToRender);
                        } catch (error) {
                          console.log("error al cargar el evento");
                          console.log("schedule", schedule);
                          console.log("error", error);
                          return `Error en el evento`;
                        }
                      }.bind(this),
                      popupEdit: function() {
                        return 'Abrir';
                      },
                      popupDelete: function() {
                        return 'Cancelar';
                      },
                      popupSave: function() {
                        return 'Crear';
                      }
                    }}
                    useDetailPopup={false}
                    useCreationPopup
                    // view={selectedView} // You can also set the `defaultView` option.
                    week={{
                      daynames: daynames,
                      narrowWeekend: true,
                      showTimezoneCollapseButton: true,
                      timezonesCollapsed: true,
                      startDayOfWeek: 1 // monday
                    }}
                    onClickSchedule={this.onClickSchedule}
                    onBeforeCreateSchedule={this.onBeforeCreateSchedule}
                    onBeforeDeleteSchedule={this.onBeforeDeleteSchedule}
                    onBeforeUpdateSchedule={this.onBeforeUpdateSchedule}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

function getReasonStyle(reason) {
  let style = {
    borderRadius: "15px",
    padding: "5px 10px",
    color: "#FFF",
    overflow: "hidden"
  };
  let icon = "";
  switch (reason) {
    // Todo correcto: verde
    case 257:
      style.background = "#00BA89";
      icon = "ui-1_check";
      break;
      // Visita pospuesta: azul
    case 261:
      style.background = "#ffb142";
      icon = "ui-1_calendar-60";
      break;
      // Incidencia ajena: amarilla
    case 260:
      style.background = "#34ace0";
      icon = "objects_support-17";
      break;
      // Incidencia propia: rojo
    case 259:
      style.background = "#b33939";
      icon = "ui-2_settings-90";
      break;
      // Cancelada: naranja
    case 258:
      style.background = "#ff793f";
      icon = "ui-1_simple-remove";
      break;    
    default:
      style.background = "#84817a";
      icon = "ui-1_settings-gear-63";
      break;
  }
  return {
    style: style,
    icon: icon
  };
}

function getReminderTarget(reminder) {
  let durationStyle = {
    color: "#FFF",
    fontWeight: "bold",
    paddingLeft: "15px",
    background: reminder.type_color,
    display: "block",
    paddingTop: "5px",
    paddingBottom: "5px"
  };
  switch (reminder.type_id) {
    // Para todos
    case 416:
      return (
        <span style={durationStyle}>
          <i
            className="now-ui-icons location_world"
            // style={{ color: "#F00" }}
          />
          {" " + (reminder ? reminder.type_name : "")}
        </span>
      );
    // Para mí
    case 415:
      return (
        <span style={durationStyle}>
          <i
            className="now-ui-icons users_single-02"
            // style={{ color: "#F00" }}
          />
          {" " + (reminder ? reminder.type_name : "")}
        </span>
      );
    default:
      return (
        <span style={durationStyle}>
          <i
            className="now-ui-icons users_single-02"
            // style={{ color: "#F00" }}
          />
          {" " + (reminder ? reminder.type_name : "")}
        </span>
      );
  }
}
function buildReminderHeaderStatus(reminder) {
  console.log("building status", reminder);
  let status_id = reminder.status_id;
  let category_id = reminder.category_id;
  let style = {
    padding: "5px 10px",
    // borderRadius: "2px",
    // margin: "0px 10px 0px 5px",
    margin: "0px 5px 0px -8px",
    borderRadius: "0px",
    boxShadow: "1px 0px 1px rgba(0,0,0,0.1)"
  };
  let durationStyle = {
    // padding: "5px 10px",
    // borderRadius: "2px",
    // margin: "0px 10px 0px 5px",
    // background: "rgba(255,255,255,0.1)",
    // color: "#FFF"
  };
  let iconStyle = {
    position: "relative",
    bottom: "-1px",
    right: "-2px"
  };
  let timeIconStyle = {
    position: "relative",
    bottom: "-2px"
  };
  let visit_status = null;
  if (reminder && status_id) {
    switch (status_id) {
      // Esperando
      case 417:
        visit_status = {
          text: reminder.status_name,
          color: "info",
          icon: "ui-2_time-alarm"
        };
        break;
      // Eliminado
      case 418:
        visit_status = {
          text: reminder.status_name,
          color: "danger",
          icon: "ui-1_simple-remove"
        };
        break;
      // Listo
      case 419:
        visit_status = {
          text: reminder.status_name,
          color: "primary",
          icon: "ui-1_check"
        };
        break;
      default:
        visit_status = {
          text: "No se pudo cargar el estado",
          color: "default",
          icon: "ui-1_simple-remove"
        };
        break;
    }
    switch (category_id) {
      // Trabajo
      case 420:
        visit_status.duration = (
          <span style={durationStyle}>
            <i className={"now-ui-icons ui-2_settings-90"} style={timeIconStyle} />
            {" " + reminder.category_name}
          </span>
        );
        break;
      // Personal
      case 421:
        visit_status.duration = (
          <span style={durationStyle}>
            <i className={"now-ui-icons gestures_tap-01"} style={timeIconStyle} />
            {" " + reminder.category_name}
          </span>
        );
        break;
      // Médico
      case 422:
        visit_status.duration = (
          <span style={durationStyle}>
            <i className={"now-ui-icons health_ambulance"} style={timeIconStyle} />
            {" " + reminder.category_name}
          </span>
        );
        break;
      default:
        visit_status = {
          text: "No se pudo cargar el estado",
          color: "default",
          icon: "ui-1_simple-remove"
        };
        break;
    }
    // console.log("built status", visit_status);
    let statusIcon = (
      <span style={style} className={"bg-" + visit_status.color}>
        <i className={"now-ui-icons " + visit_status.icon} style={iconStyle} />
        {/* {" "}{visit_status.text} */}
      </span>
    );
    let statusTime = visit_status.duration;
    return {
      icon: statusIcon,
      time: statusTime
    };
  }
  return null;
}
function cancelScheduleChanges() {
  let schedule = this.state.scheduleUpdating;
  // console.log("CANCEL CHANGES");
  // console.log(schedule);
  let calendar = this.refs.cal.calendarInst;
  // let dateComponents = homeVisit.visit_date_day.split("/");
  // let day = parseInt(dateComponents[0]);
  // let month = parseInt(dateComponents[1]);
  // let year = parseInt(dateComponents[2]);
  // let hourComponents = homeVisit.visit_date_hour.split(":");
  // let hour = parseInt(hourComponents[0]);
  // let minutes = parseInt(hourComponents[1]);
  // let start = new Date(year, month - 1, day, hour, minutes);
  // let end = new Date(year, month - 1, day, hour, minutes);
  // end.setTime(end.getTime() + 2 * 60 * 60 * 1000);
  let changes = {
    start: schedule.start,
    end: schedule.end
  };
  // console.log("CHANGES TO CANCEL", {
  //   schedule_id: schedule.id,
  //   calendar: schedule.calendarId,
  //   changes: changes
  // });
  calendar.updateSchedule(schedule.id, schedule.calendarId, changes);
}

export default Reminders;



// WEBPACK FOOTER //
// ./src/views/Reminders/Reminders.jsx